import type { ThresholdChartData } from './ThresholdChart'

interface MiniLineProps {
  chart: ThresholdChartData
}

const width = 200
const height = 56
const inset = 4
const plotWidth = width - inset * 2
const plotHeight = height - inset * 2

export function MiniLine({ chart }: MiniLineProps) {
  const x = (index: number) => inset + plotWidth * index / (chart.vals.length - 1)
  const y = (value: number) => inset + plotHeight - plotHeight * (value - chart.lo) / (chart.hi - chart.lo)
  const path = chart.vals.map((value, index) => `${index === 0 ? 'M' : 'L'}${x(index).toFixed(1)} ${y(value).toFixed(1)}`).join(' ')

  return (
    <svg viewBox={`0 0 ${width} ${height}`} width={width} height={height} aria-hidden="true">
      <line x1="0" x2={width} y1={y(chart.threshold).toFixed(1)} y2={y(chart.threshold).toFixed(1)} stroke="var(--red-600)" strokeWidth="1" strokeDasharray="3 3" />
      <path d={path} fill="none" stroke="var(--blue-600)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      {chart.vals.map((value, index) => (
        <circle key={`${value}-${index}`} cx={x(index).toFixed(1)} cy={y(value).toFixed(1)} r="2.6" fill={value > chart.threshold ? 'var(--red-600)' : 'var(--blue-600)'} stroke="var(--surface)" strokeWidth="1.2" />
      ))}
    </svg>
  )
}
